const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  addPaddingTop: state => state.app.addPaddingTop,
  searchParams: state => state.app.searchParams,
  token: state => state.user.token,
  username: state => state.user.username,
  deposit: state => state.user.deposit,
  point: state => state.user.point,
  mobile: state => state.user.mobile,
  type: state => state.user.type,
  memberLevelInfo: state => state.user.memberLevelInfo,
  memberDetail: state => state.user.memberDetail,
  cartCount: state => state.user.cartCount,
  alarmCount: state => state.user.alarmCount,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  wishList: state => state.wish.wishList,
  userId: state => state.user.userId,
  loginId: state => state.user.loginId,
  shopInfo: state => state.shop.shopInfo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js